/**
 * Soul Hippy header — mobile drawer, shop dropdown, scroll solid state
 */
(function () {
  const SCROLL_THRESHOLD = 8;

  function updateSolidState(header) {
    if (!header.classList.contains('sh-header--overlay')) {
      header.classList.add('is-solid');
      return;
    }
    const solid = window.scrollY > SCROLL_THRESHOLD;
    header.classList.toggle('is-solid', solid);
  }

  function initHeader(header) {
    if (!header || header.dataset.shHeaderReady) return;
    header.dataset.shHeaderReady = 'true';

    const toggle = header.querySelector('[data-sh-menu-toggle]');
    const dropdowns = header.querySelectorAll('[data-sh-dropdown]');

    toggle?.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    dropdowns.forEach((dropdown) => {
      const btn = dropdown.querySelector('[data-sh-dropdown-toggle]');
      btn?.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = dropdown.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        dropdowns.forEach((other) => {
          if (other !== dropdown) {
            other.classList.remove('is-open');
            other.querySelector('[data-sh-dropdown-toggle]')?.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });

    document.addEventListener('click', (e) => {
      if (!header.contains(e.target)) {
        header.classList.remove('is-open');
        toggle?.setAttribute('aria-expanded', 'false');
        dropdowns.forEach((d) => {
          d.classList.remove('is-open');
          d.querySelector('[data-sh-dropdown-toggle]')?.setAttribute('aria-expanded', 'false');
        });
      }
    });

    updateSolidState(header);

    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          updateSolidState(header);
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function initAll() {
    document.querySelectorAll('[data-sh-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-sh-header]').forEach((header) => {
      delete header.dataset.shHeaderReady;
      initHeader(header);
    });
  });
})();
